module.exports = __webpack_public_path__ + "img/raccoon.739880d1.png";